/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardController', DinghyEventBoardController);

    DinghyEventBoardController.$inject = ['$state', 'Principal', 'DinghyEventBoard', 'DinghyEventSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', '$timeout'];

    function DinghyEventBoardController($state, Principal, DinghyEventBoard, DinghyEventSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, $timeout) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });
        vm.isDinghy = false;
        Principal.hasAuthority('ROLE_DINGHY').then(function (result) {
            vm.isDinghy = result;
        });
        vm.dinghyEventTypes = ['all', 'without_godparent', 'personal', 'leisure', 'regatta', 'training', 'engagement', 'local'];
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicateE;
        vm.reverse = pagingParams.ascendingE;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.searchE;
        vm.currentSearch = pagingParams.searchE;
        vm.setType = setType;
        vm.setArchive = setArchive;
        vm.archive = pagingParams.archiveE;
        vm.type = pagingParams.typeE;
        vm.events = [];

        if (vm.predicate.startsWith('godparent') && (vm.type === 'personal' || vm.type === 'without_godparent')) {
            vm.predicate = 'fromDate';
            vm.reverse = true;
            $timeout(function() {
                vm.transition();
            });
        } else {
            loadAll();
        }

        function setType(type) {
            vm.page = 1;
            vm.type = type;
            vm.transition();
        }

        function setArchive(archive) {
            vm.page = 1;
            vm.archive = archive;
            vm.transition();
        }

        function loadAll () {
            if (pagingParams.searchE) {
                DinghyEventSearch.query({
                    query: pagingParams.searchE,
                    page: pagingParams.pageE - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DinghyEventBoard.query({
                    page: pagingParams.pageE - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    archive: $stateParams.archiveE,
                    type: $stateParams.typeE
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.events = data;
                vm.page = pagingParams.pageE;
                if (vm.events.length === 0 && vm.predicate.startsWith('godparent')) {
                    vm.predicate = 'fromDate';
                    vm.reverse = true;
                    vm.transition();
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                pageE: vm.page,
                sortE: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchE: vm.currentSearch,
                archiveE: vm.archive,
                typeE: vm.type
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'fromDate';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
